import { atom } from 'jotai';

/** `/membership/member` 응답 등에서 쓰는 로그인 사용자 스냅샷 (`profile`은 null·문자열 레거시 가능) */
export type MembershipProfile = {
  defaultBackgroundColor?: string;
  file?: { resourceUri?: string } | null;
};

export type MembershipUserData = {
  id?: string | number;
  profile?: MembershipProfile | string | null;
  name?: {
    fullName?: string;
    first?: string;
    last?: string;
  };
  dutyName?: string;
  dutyRole?: { text?: string };
  responsibilityName?: string;
  lastLoginTime?: string;
  roles?: unknown[];
};

export const memberImageUrlAtom = atom<string>('');
export const memberNameAtom = atom<string>('');
export const memberFirstNameAtom = atom<string>('');
export const memberLastNameAtom = atom<string>('');
export const memberDutyNameAtom = atom<string>('');
export const memberDutyRoleNameAtom = atom<string>('');
export const memberResponsibilityNameAtom = atom<string>('');
export const memberIdAtom = atom<string | number>('');
export const lastLoginAtom = atom<string>('');
export const memberRoleList = atom<any[]>([]);

export const userData = atom<MembershipUserData | null>(null);
